import { useEffect, useState, lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import jsCookie from 'js-cookie';
import { ChakraProvider,  } from '@chakra-ui/react';
import { signOutUserSuccess } from 'store/slices/userSlice';
import initialTheme from './theme/theme';
import Preloader from 'loader/Preloader';



// Lazy-loaded components
const HomePage = lazy(() => import('pages/home'));
const AuthControl = lazy(() => import('pages/auth'));

const PrivateRoute = lazy(() => import('pages/auth/PrivateRoute'));
const OwnerLayout = lazy(() => import('pages/start/layout/owner'));
const AdminLayout = lazy(() => import('./layouts/admin'));
const NoRouteFound = lazy(() => import('loader/NoRouteFound'));

export default function Main() {


  const dispatchRed = useDispatch();
  // Get token from cookies 
  const token = jsCookie.get('token');
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  useEffect(() => {
    signOutNavigator();
  }, [token,]);

  function signOutNavigator() {
    if (!token) {
      dispatchRed(signOutUserSuccess());
      return <Navigate to="/auth/login" />;
    }
  }
  useEffect(() => {

    // Get current URL's search parameters
    const params = new URLSearchParams(window.location.search);

    // Extract token and user_id
    const tokenFromUrl = params.get('token');
    const userIdFromUrl = params.get('user_id');

    if (tokenFromUrl) {
      
      // Optionally store it in localStorage for persistent usage
      localStorage.setItem('auth_token', tokenFromUrl);
      jsCookie?.set('token', tokenFromUrl);
    }

    if (userIdFromUrl) {
   
      localStorage.setItem('user_id', userIdFromUrl);
      jsCookie?.set('ltip_user', userIdFromUrl);

    }

  }, []);



  return (
    <ChakraProvider  theme={currentTheme}>
      <Suspense fallback={<Preloader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<AuthControl />} />
          {/* <Route path="/user-login" element={<WorkersLoginPage />} /> */}
          {/* <Route path="/auth-redirect" element={<AuthRedirect />} /> */}
          <Route element={<PrivateRoute />}>
            <Route
              path="owner/*"
              element={<OwnerLayout theme={currentTheme} setTheme={setCurrentTheme} />}
            />
            <Route
              path="admin/*"
              element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />}
            />
            
          </Route>
          {/* <Route path="/admin/default/*" element={<FallbackRoute />} /> */}
          <Route path="*" element={<NoRouteFound />} />
        </Routes>
      </Suspense>
    </ChakraProvider>
  );
}
